import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {}

interface Variables {
    input: {
        agreementName: string,
        packageId: string,
    }
}

export const UPDATE_AGREEMENT: TypedDocumentNode<Result, Variables> = gql`
    mutation UpdateAgreementAndPackage($input: AgreementAndPackageInput!) {
        updateAgreementAndPackage(input: $input)
    }       
`
